import { useState } from 'react';

const useColorSelector = (colorContainer, defaultColor) => {
  const [firstColor] = colorContainer.fields || [];
  const prepareColor = (newContainer, newDefaultColor) => {
    const modifiedDefaultColor = newDefaultColor || firstColor;
    return newContainer?.fields?.map(({ name, hexValue, detKey, swatch, colorName }) => ({
      name: colorName.value,
      neutralName: name,
      color: hexValue.value,
      key: detKey.value,
      image: swatch?.item?.value,
      isSelected: detKey.value === (modifiedDefaultColor?.fields?.detKey?.value || modifiedDefaultColor?.key),
      isValid: true,
    }));
  };

  const [colors, setColors] = useState(prepareColor(colorContainer, defaultColor));

  const selectedColor = colors.find(color => color.isSelected);
  const selectedIndex = colors.findIndex(color => color.isSelected);
  const onColorSelected = key => {
    setColors(colors.map(color => ({ ...color, isSelected: color.key === key })));
  };
  const onCarouselColorSelected = colorIndex => {
    setColors(colors.map((color, index) => ({ ...color, isSelected: index === colorIndex })));
  };

  return { selectedColor, selectedIndex, onColorSelected, onCarouselColorSelected, colors };
};

export default useColorSelector;
